<div class="flex flex-col gap-2" [formGroup]="platformLicenseActivationForm">
    <div class="flex flex-row justify-center gap-4">
        <div class="form-control w-72">
            <label class="label">
                <span class="text-base font-bold" i18n>Starting Date</span>
            </label>
            <input
                type="date"
                class="input input-bordered w-full"
                [ngClass]="{ 'border-error': platformLicenseActivationForm.get('effectiveFrom').invalid }"
                formControlName="effectiveFrom"
            />
            <label
                class="label"
                *ngIf="
                    platformLicenseActivationForm.get('effectiveFrom').dirty && platformLicenseActivationForm.get('effectiveFrom').invalid
                "
            >
                <span class="text-xs text-error" i18n>The Starting Date must be set!</span></label
            >
        </div>

        <div class="form-control w-72">
            <label class="label">
                <span class="text-base font-bold" i18n>Ending Date</span>
            </label>
            <input
                type="date"
                class="input input-bordered w-full"
                [ngClass]="{ 'border-error': platformLicenseActivationForm.get('effectiveTo').invalid }"
                formControlName="effectiveTo"
            />
            <label
                class="label"
                *ngIf="platformLicenseActivationForm.get('effectiveTo').dirty && platformLicenseActivationForm.get('effectiveTo').invalid"
            >
                <span class="label-text-alt text-left text-error" i18n>Ending date is invalid!</span>
            </label>
        </div>
    </div>
    <div class="w-full text-center">
        <span class="text-sm text-error" *ngIf="platformLicenseActivationForm.hasError('effectiveToIsBeforeEffectiveFrom')" i18n
            >The Ending date can't be before the Starting date</span
        >
    </div>
</div>
